import { create } from 'zustand'

interface SetLEContactId {
  passedLEContactId: number | undefined
  setPassedLEContactId: (passedLEContactId: number | undefined) => void
}

export const useSetLEContactId = create<SetLEContactId>((set) => ({
  passedLEContactId: undefined,
  setPassedLEContactId: (passedLEContactId: any) => {
    set({ passedLEContactId })
  },
}))
